/**
 * @generated SignedSource<<64818bacea198384e05a701e8d56e397>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RoadmapsContent_navigationCustomisation$data = {
  readonly sidebar: {
    readonly nodes: ReadonlyArray<{
      readonly menuId: string | null;
      readonly visible: boolean | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "RoadmapsContent_navigationCustomisation";
};
export type RoadmapsContent_navigationCustomisation$key = {
  readonly " $data"?: RoadmapsContent_navigationCustomisation$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapsContent_navigationCustomisation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RoadmapsContent_navigationCustomisation",
  "selections": [
    {
      "concreteType": "SettingsMenuItemConnection",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "menuId"
            },
            {
              "kind": "ScalarField",
              "name": "visible"
            }
          ]
        }
      ]
    }
  ],
  "type": "SettingsNavigationCustomisation"
};

(node as any).hash = "5d3559e77a966f5cf722d36b5de5e49f";

export default node;
